import { useState, useEffect } from 'react'
import { Program } from '../types'
import { fetchProgramSearch } from '../utils/program'

export function useProgramSearch(search: string) {
  const [data, setData] = useState<Program[] | null>(null)
  const [isLoading, setIsLoading] = useState<boolean>(true)
  const [error, setError] = useState<Error | null>(null)

  useEffect(() => {
    async function load() {
      setIsLoading(true)
      try {
        const channels = await fetchProgramSearch(search)
        setData(channels)
      } catch (err) {
        setError(err as Error)
      } finally {
        setIsLoading(false)
      }
    }
    load()
  }, [search])

  return { data, isLoading, error }
}
